import React from 'react';
import Select from 'react-select';

const selectStyles = {
  container: (base) => ({ ...base, marginTop: -15 }), // <— lift slightly
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    height: 44,
    borderRadius: 8,
    borderColor: state.isFocused ? "#4A9B8F" : "#ddd",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(74,155,143,.15)" : "none",
    "&:hover": { borderColor: "#4A9B8F" },
    fontFamily: "'Gotham Rounded', sans-serif",
    fontSize: 14,
  }),
  valueContainer: base => ({ ...base, padding: "0 10px" }),
  input: base => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: base => ({ ...base, height: 44 }),
  placeholder: base => ({ ...base, color: "#6B7280" }),
  menu: base => ({ ...base, zIndex: 9999, borderRadius: 8, overflow: "hidden" }),
  // Group header (e.g. a parent category like "EXTERIOR WALLS") — reads as a
  // clear section divider above its sub-categories.
  groupHeading: base => ({
    ...base,
    fontSize: 11.5,
    fontWeight: 800,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#2f7d72",
    background: "#eef5f3",
    padding: "8px 12px",
    margin: 0,
  }),
  group: base => ({ ...base, paddingTop: 0, paddingBottom: 4 }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    backgroundColor: state.isFocused ? "#E6F3F7" : state.isSelected ? "#4A9B8F" : "white",
    color: state.isSelected ? "white" : "#243c4c",
  }),
};

const StyledDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  name,
  isClearable = true,
}) => {
  // Support both flat options and grouped options ({ label, options: [...] }).
  const flatOptions = (options || []).flatMap(o => (o && o.options ? o.options : [o]));
  return (
    <Select
      inputId={name}
      name={name}
      options={options}
      value={flatOptions.find(o => o.value === value) || null}
      onChange={(opt) => onChange(opt?.value || '')}
      placeholder={placeholder}
      isClearable={isClearable}
      styles={selectStyles}
      classNamePrefix="nz-select"
      menuPortalTarget={document.body}
    />
  );
};

export default StyledDropdown;
